import { FC, ReactElement } from 'react';

import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { Picture } from '../../../../components';
import { WayfindingWrapper } from '../../../../compositions';
import { WayfindingType } from '../../../../entities/@navigation/Wayfinding/Wayfinding';
import { ProductCategory, ProductCategoryImageType } from '../../../../entities/@products/ProductCategory/ProductCategory';
import { AppRoute, appRoutes } from '../../../../entities/Routing/Routing';
import { replaceUrlParamKeysWithValues } from '../../../../helpers/url';
import { useTrans } from '../../../../hooks';

import './CategoryCard.scss';

export interface CategoryCardProps extends ProductCategory {
    className?: string;
}

export const CategoryCard: FC<CategoryCardProps> = ({
    id,
    slug,
    name,
    image,
    imageType,
    className = '',
}): ReactElement => {
    const trans = useTrans();

    const productCategoryPath = trans(appRoutes[AppRoute.productCategory].path);
    const productCategoryUrl = replaceUrlParamKeysWithValues(productCategoryPath, {
        slug,
        subCategory: undefined,
        subSubCategory: undefined,
    });

    const cardClassNames = classNames('category-card', {
        'category-card--is-normal': imageType === ProductCategoryImageType.defaultImage,
    }, className);

    const pictureClassNames = classNames('category-card__picture', {
        'category-card__picture--is-normal': imageType === ProductCategoryImageType.defaultImage,
    });

    const imageClassNames = classNames('category-card__image', {
        'category-card__image--is-covered': imageType === ProductCategoryImageType.defaultImage,
    });

    return (
        <div className={cardClassNames}>
            <WayfindingWrapper
                id={id}
                type={WayfindingType.enter}
                label={trans('common.view')}
                className={pictureClassNames}
                iconPathClassName="category-card__wayfinding-icon-path"
            >
                <Link to={productCategoryUrl}>
                    <Picture
                        {...image}
                        className={pictureClassNames}
                        imageClassName={imageClassNames}
                    />

                    <div className="category-card__text-wrapper">
                        <h3 className="category-card__title">
                            {name}
                        </h3>
                    </div>
                </Link>
            </WayfindingWrapper>

        </div>
    );
};
